import store from "@/store";
import { $getURLParameterVal } from "@Utils";
import { ForgeMessage, isParentOrigin } from "@/utils/forgeMessageUtils";
import { getAttachment, getAttachmentByReference, postAttachment } from "@/utils/mongoUtils";
import { ForgeAttachment } from "../js/forgeModels";

export async function createMarkupsApp() {
    if(!document.getElementById('markupsApp')) return;
    
    var attachmentId = $getURLParameterVal('attachmentId');
    var documentId = $getURLParameterVal('documentId');
    var referenceContextId = $getURLParameterVal('referenceContextId');
    var referenceContentId = $getURLParameterVal('referenceContentId');
    var documentUrl = (isParentOrigin() ? window.top.location.origin : '') + $getURLParameterVal('documentUrl', true);
    var name = $getURLParameterVal('name');
    var documentAbsoluteUrl = $getURLParameterVal('documentAbsoluteUrl', true);
    var pageNumber = $getURLParameterVal('page');
    var referencePageNumber = $getURLParameterVal('referencePageNumber');

    /*
    Markup viewer can be called by one of those cases::
    ==>>Cases:
        01. Show Document with {attachmentId} as primary key
            Required Query Parameters: [attachmentId, type]
            Optional Query Parameters: [name, documentUrl, page, isMarkupImage, view, url]
            //http://localhost:18999/markupsLocal.html?attachmentId=62

        02. Show Document with {documentUrl} without any external key
            Required Query Parameters: [type, documentUrl]
            Required Query Parameters-Reality: [token, assetId, assetName, userId, userName, email]
            Required Query Parameters-Origin: [moduleUrl, testPackageNumber]
            Optional Query Parameters: [name, page, isMarkupImage, view, url]
        
        03.Open Document with {documentId} and {referenceContextID} as FKs
            Required Query Parameters: [type, documentUrl, documentId, referenceContextID]
            Required Query Parameters-Reality: [token, assetId, assetName, userId, userName, email]
            Required Query Parameters-Origin: [documentAbsoluteUrl, moduleUrl, testPackageNumber]
            Optional Query Parameters: [name, page, isMarkupImage, view, url]
            //http://localhost:18999/markupsLocal.html?documentUrl=aHR0cHM6Ly9yZWFsaXR5YmxvYnN0b3JhZ2UuYmxvYi5jb3JlLndpbmRvd3MubmV0L2ZvcmdlLXJlYWxpdHkvMTQ1JTJGJTI0YXR0YWNobWVudHMlMkY5MTU2Yjc2Mi05MDQxLTRkODEtYTdjOC1mNzc1ZDJiOWI1ODcucGRm&page=1

            //eg reality
            //https://forgedev.mods.solutions/markupsLocal.html?documentId=145&isMarkupImage=1&type=reality&referenceContextId=realityDochub&documentUrl=aHR0cHM6Ly9yZWFsaXR5YmxvYnN0b3JhZ2UuYmxvYi5jb3JlLndpbmRvd3MubmV0L2ZvcmdlLXJlYWxpdHkvMTQ1JTJGYXR0YWNobWVudHMlMkYwZGJjMTE0Yi1mYWIwLTRhMjMtYTkwYi03YjMyMTkzMTExMWMuanBn
            
            //eg reality flutter - by documentUrl
            //https://forgedev.mods.solutions/markupsLocal.html?documentId=145&isMarkupImage=1&type=realityFlutter&referenceContextId=realityDochub&documentUrl=aHR0cHM6Ly9yZWFsaXR5YmxvYnN0b3JhZ2UuYmxvYi5jb3JlLndpbmRvd3MubmV0L2ZvcmdlLXJlYWxpdHkvMTQ1JTJGYXR0YWNobWVudHMlMkYwZGJjMTE0Yi1mYWIwLTRhMjMtYTkwYi03YjMyMTkzMTExMWMuanBn
            //http://localhost:18999/markupsLocal.html?documentId=145&isMarkupImage=1&type=realityFlutter&referenceContextId=realityDochub&documentUrl=aHR0cHM6Ly9yZWFsaXR5YmxvYnN0b3JhZ2UuYmxvYi5jb3JlLndpbmRvd3MubmV0L2ZvcmdlLXJlYWxpdHkvMTQ1JTJGYXR0YWNobWVudHMlMkYwZGJjMTE0Yi1mYWIwLTRhMjMtYTkwYi03YjMyMTkzMTExMWMuanBn

            //eg reality flutter - by image64
            //https://forgedev.mods.solutions/markupsLocal.html?documentId=145&isMarkupImage=1&type=realityFlutter&referenceContextId=realityDochub&documentUrl=aHR0cHM6Ly9yZWFsaXR5YmxvYnN0b3JhZ2UuYmxvYi5jb3JlLndpbmRvd3MubmV0L2ZvcmdlLXJlYWxpdHkvMTQ1JTJGYXR0YWNobWVudHMlMkYwZGJjMTE0Yi1mYWIwLTRhMjMtYTkwYi03YjMyMTkzMTExMWMuanBn
            //http://localhost:18999/markupsLocal.html?documentId=145&isMarkupImage=1&type=realityFlutter&referenceContextId=realityDochub&documentUrl=aHR0cHM6Ly9yZWFsaXR5YmxvYnN0b3JhZ2UuYmxvYi5jb3JlLndpbmRvd3MubmV0L2ZvcmdlLXJlYWxpdHkvMTQ1JTJGYXR0YWNobWVudHMlMkYwZGJjMTE0Yi1mYWIwLTRhMjMtYTkwYi03YjMyMTkzMTExMWMuanBn
            //drawImageOnPlane('https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Image_created_with_a_mobile_phone.png/640px-Image_created_with_a_mobile_phone.png',markupsComponent.markupViewer)

            //https://forgedev.mods.solutions/markupsLocal.html?documentId=145&isMarkupImage=1&type=reality&referenceContextId=realityDochub&documentUrl=aHR0cHM6Ly9yZWFsaXR5YmxvYnN0b3JhZ2UuYmxvYi5jb3JlLndpbmRvd3MubmV0L2ZvcmdlLXJlYWxpdHkvMTQ1JTJGYXR0YWNobWVudHMlMkYwZGJjMTE0Yi1mYWIwLTRhMjMtYTkwYi03YjMyMTkzMTExMWMuanBn
            //https://localhost:44340//markupsLocal.html?documentId=145&isMarkupImage=1&type=reality&referenceContextId=realityDochub&documentUrl=aHR0cHM6Ly9yZWFsaXR5YmxvYnN0b3JhZ2UuYmxvYi5jb3JlLndpbmRvd3MubmV0L2ZvcmdlLXJlYWxpdHkvMTQ1JTJGYXR0YWNobWVudHMlMkYwZGJjMTE0Yi1mYWIwLTRhMjMtYTkwYi03YjMyMTkzMTExMWMuanBn

    ==>>Sample Src value:
        forgeIframeElement.src = `${forgeApiUrl}/markups.html?type=origin&moduleUrl=${moduleUrlBase64}&referenceContextId=${testPackageId}&documentId=${documentId}&documentAbsoluteUrl=${documentAbsoluteUrlBase64}&documentUrl=${documentUrlBase64}`;

    //markup viewer can ba called by one of those
    //it creates attachment in db iif not created and show the user the markup and finally save it to the created entity in db
    //TODO: Bary to document the other cases



    ==>>Parameters
        attachmentId: attachmentId in forge DB (int)
        type        : parent site type, sample [reality, origin, ] (string, base64)
        documentUrl : attachment PDF signed & public URL (string, base64)
        name        : attachment Name (string, base64)
        page        : Page number to be opened (int)
        isMarkupImage: bool defines whether the opened attachment is an PNG (bool, default 0)
        view        : open a specified viewer sample [3d, doc, ..] (string, default Empty)
        url         : url of parent site (string, base64)
        moduleUrl   : sub url of parent site active module, used for parent site requests url [/piping-api, /permit-api](string, base64)
        documentId  : documentId in parent site DB (string)
        referenceContextID  : Document context ID in parent site DB sample: [testPackageID, IssueID, CertificateID, Doc-hub, ..] (string)
        referenceContentID  : Document content/folder ID in parent site DB sample: [DocumentOutputID, FolderID] (string)
        documentAbsoluteUrl : attachment PDF absolutePath (string, base64)
        referencePageNumber : reference page number in Origin (int)
        testPackageNumber   : Active Test Package number in Origin (string)
    */
    // await delay(200);
    setTimeout(async () => {
        store.state.markupsComponent = store.state.markupsApp.$children[0];
        var attachment;
        if (attachmentId) {
            attachment = await getAttachment(attachmentId);
            attachment.id = attachmentId;
        }
        if (documentId && referenceContextId) {
            attachment = await getAttachmentByReference(documentId, referenceContextId, referenceContentId);
        }

        if (!attachment || !attachment?.id) { //Attachment not in DB yet
            attachment = new ForgeAttachment();
        }
        if (name) {
            attachment.name = name;
        }
        if (documentId) {
            attachment.referenceDocumentId = documentId;
        }
        if (referenceContextId) {
            attachment.referenceContextId = referenceContextId;
        }
        if (referenceContentId) {
            attachment.referenceContentId = referenceContentId;
        }
        if (documentUrl) {
            attachment.url = documentUrl;
        }
        if (documentAbsoluteUrl) {
            attachment.absoluteUrl = documentAbsoluteUrl;
        }

        if (referencePageNumber) {
            attachment.referencePageNumber = referencePageNumber / 1;
        }

        if (!isNaN(pageNumber)) pageNumber *= 1;
        
        store.state.markupsComponent = store.state.markupsApp.$children[0];
        store.state.markupsComponent.showAttachment(attachment, true, pageNumber);

        store.commit('setActiveAttachment', attachment);

        postAttachment(attachment, (attachmentData) => {
            attachment.id = attachmentData?.id
            ForgeMessage.sendMessageToParent('markups-attachment', attachmentData)
        });
    }, 200);
}